import { EditOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router'

export const EditIcon: React.FC<{ to: string }> = ({ to }) => {
  const navigate = useNavigate()
  const redirect = () => navigate(to)

  return <EditOutlined className=' ml-2 cursor-pointer text-lg align-middle' onClick={redirect} />
}
